import request from '../helpers/request'

export default {
  getBlocks: async ({ uid, productId, categoryId }) => {
    const params = { uid }

    if (productId) params['product_id'] = productId

    if (categoryId) params['category_id'] = categoryId

    const { data } = await request.get('/shop/catalog/get-blocks/', { params })

    return data
  },
  getFixedBlockProducts: async ({ id, offset = null, categoryId = null }) => {
    const params = { id }

    if (offset) params['offset'] = offset

    if (categoryId) params['category_id'] = categoryId

    const { data } = await request.get('/shop/catalog/get-block-products/', { params })

    return data
  },
  getEsputnikRecommendations: async ({ skus, show_out_of_stock, drop_out_of_stock }) => {
    const params = { skus, show_out_of_stock, drop_out_of_stock }

    const { data } = await request.get('/shop/catalog/get-esputnik-recommendations/', { params })

    return data
  }
}
